<template>
  <div class="px-2 mt-14 mb-6">
    <v-row>
      <v-col v-for="n in columns" :key="`${n}-header`" justify="center">
        <div class="justify-center">
          <v-skeleton-loader class="justify-center me-0" type="heading" />
        </div>
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader type="divider" class="my-2" />
      </v-col>
    </v-row>
    <v-row class="mt-4" v-for="n in rows" :key="n">
      <v-col v-for="n in columns" :key="`${n}-text`">
        <v-skeleton-loader type="text" />
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader type="divider" class="my-2" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TableSkeleton',

  props: {
    columns: {
      type: Number,
      default: 4,
    },
    rows: {
      type: Number,
      default: 5,
    },
  },
}
</script>
